// extracted by mini-css-extract-plugin
module.exports = {"view-slider-item-wrapper-image":"styles__view-slider-item-wrapper-image__3N97b","viewSliderItemWrapperImage":"styles__view-slider-item-wrapper-image__3N97b"};